// Converted from application/views/next_exhibitions/china_2026_v.php. Edit this component directly.
export default function NextExhibitionsChina2026Page() {
  return <><h1>{"From Ireland to China: Paddy Campbell's Wind & Sea Crowns New Hangzhou Landmark"}</h1>
<h2 style={{"textAlign":"center","margin":"0 0 6rem 0"}}>
<em>{"Monumental 4.30-Metre Bronze Marks the Formal Inauguration of Hangzhou's Newest Complex on 29 October"}</em>
</h2>
<style>{"\n    .china-feature-images img {\n        aspect-ratio: 3 / 4;\n        object-fit: cover;\n    }\n"}</style>
<div class={"row china-feature-images"}>
<div class={"column"}>
<figure>
<img src={"/assets/images/china-exhibition/Banner-china.jpg"} alt={"La Forma e l'Invisibile exhibition poster"} />
</figure>
</div>
<div class={"column"}>
<figure>
<img src={"/assets/images/china-exhibition/Wind&Sea-36.jpg"} alt={"Wind and Sea, a bronze sculpture by Paddy Campbell"} />
<figcaption>{"Wind & Sea"}</figcaption>
</figure>
</div>
</div>
<div class={"row"}>
<div class={"column solo"}>
<p>
<em>{"Irish sculptor Paddy Campbell's bronze work takes pride of place at the entrance\n            of a major new development in Hangzhou, China."}</em>
</p>
<p><strong>{"Hangzhou, China - 29 October 2026"}</strong></p>
<p>{"\n            Irish sculptor Paddy Campbell's monumental bronze sculpture "}<em>{"Wind & Sea"}</em>{"\n            stands at the entrance of Hangzhou's newest landmark complex as the development\n            celebrates its formal inauguration today, 29 October, marking the completion of its\n            residential, business and hotel spaces.\n        "}</p>
<p>{"\n            Standing approximately 4.10 metres high, "}<em>{"Wind & Sea"}</em>{" was first symbolically\n            unveiled on 16 September, as part of the ribbon-cutting ceremony for the complex's\n            ground-floor commercial area. Today's inauguration marks the full realisation of that\n            moment, with Campbell's sculpture now anchoring the development as its centrepiece.\n        "}</p>
<p>{"\n            The sculpture forms part of "}<em>{"“La Forma e l'Invisibile”"}</em>{", an exhibition of\n            Italian sculpture presented by Frilli Gallery (Italy) and TCC (Hangzhou), running from\n            16 September 2026 to 10 August 2027 at the ICC C.F. Koo Building, Qianjiang Century\n            City, Hangzhou.\n        "}</p>
</div>
</div>
<div class={"row"}>
<div class={"column"}>
<h2>{"About Wind & Sea"}</h2>
<p>
<em>{"Wind & Sea"}</em>{" captures the elemental, ever-shifting relationship between two\n            of nature's most powerful forces. Campbell describes the two elements as locked in a\n            dance of tension and tenderness, dancing, playing, teasing, flirting and touching,\n            before rising together in a storm that reaches for the stars and the moon.\n        "}</p>
</div>
<div class={"column"}>
<figure>
<img src={"/assets/images/china-exhibition/IMG_3093.JPG"} alt={"Wind and Sea in progress in Paddy Campbell's studio"} />
<figcaption>{"Wind & Sea in progress"}</figcaption>
</figure>
</div>
</div>
<div class={"row"}>
<div class={"column"}>
<h2>{"About Paddy Campbell"}</h2>
<p>{"\n            Paddy Campbell is a sculptor from Ireland. Though he loved creating shapes as a child,\n            it was not until the age of 60 that he discovered his gift for figurative sculpture. In\n            the 25 years since, he has dedicated himself to the craft, creating works in bronze and\n            marble.\n        "}</p>
<p>{"\n            Paddy Campbell’s studio is in Florence, Italy. In 2023 he received the prestigious\n            “Giotto e Dell ‘Angelico” award for his contribution to art and culture in Tuscany.\n        "}</p>
<p>{"\n            The idea for "}<em>{"Wind & Sea"}</em>{" first came to Campbell in his dreams. He spent the\n            following year captivated by the challenge of bringing wind and sea to life, drawn from\n            watching a storm whip the waves along the coast, an image that revealed to him the\n            increasingly tempestuous, intimate relationship between the two elements.\n        "}</p>
</div>
<div class={"column"}>
<figure>
<img src={"/assets/images/china-exhibition/IMG_3022_1%20Paddy%20working%20in%20studio%20via%20luna%20.JPG"} alt={"Paddy Campbell working on a sculpture in his studio"} />
<figcaption>{"Paddy Campbell at work in his studio"}</figcaption>
</figure>
</div>
</div>
<div class={"row"}>
<div class={"column solo"}>
<h2>{"In the Artist's Words"}</h2>
<blockquote style={{"marginLeft":"0","marginRight":"0","textAlign":"left"}}>{"\n            “I'm privileged to take part in this exhibition with Frilli Gallery in Hangzhou. To\n            have my work presented here in China - the land of warriors, fiery dragons, ancient\n            cities, and defiant gates, is one of the great moments of my life as an artist.”\n            "}<br />{"\n            ~ Paddy Campbell\n        "}</blockquote>
</div>
</div>
<div class={"row"}>
<div class={"column solo"}>
<p>
<strong>{"Exhibition at:"}</strong>
<em>{"“La Forma e l'Invisibile”"}</em>{", ICC C.F. Koo\n            Building, Qianjiang Century City, Hangzhou, China. The city of Hangzhou is a United\n            Nations World Heritage site.\n        "}</p>
</div>
</div>
</>;
}
